import React, { useState } from 'react';
import { toast } from 'sonner';
import { useLanguage } from '../context/LanguageContext';
import { translations } from '../data/translations';

const nl = translations.newsletter;

export const NewsletterSignup = ({ source }) => {
  const { language, t } = useLanguage();
  const [email, setEmail] = useState('');
  const [sending, setSending] = useState(false);

  const handleSubmit = async (e) => {
    e.preventDefault();
    setSending(true);
    try {
      const res = await fetch(`${process.env.REACT_APP_BACKEND_URL}/api/newsletter`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ email, language, source })
      });
      if (!res.ok) throw new Error('failed');
      const data = await res.json();
      toast.success(t(data.status === 'already_subscribed' ? nl.already : nl.success));
      setEmail('');
    } catch {
      toast.error(t(nl.error));
    } finally {
      setSending(false);
    }
  };

  return (
    <div data-testid={`newsletter-${source}`} style={{ maxWidth: '480px', margin: '0 auto', textAlign: 'center' }}>
      <p className="meta-text" style={{ color: 'var(--gold-accent)', marginBottom: '12px' }}>{t(nl.title)}</p>
      <p className="body-small" style={{ color: 'var(--text-secondary)', marginBottom: '20px' }}>{t(nl.desc)}</p>
      <form onSubmit={handleSubmit} style={{ display: 'flex', gap: '0', borderBottom: '1px solid var(--border-medium, #c9c5b9)' }}>
        <input
          data-testid={`newsletter-${source}-email-input`}
          type="email"
          required
          value={email}
          onChange={(e) => setEmail(e.target.value)}
          placeholder={t(nl.placeholder)}
          aria-label={t(nl.placeholder)}
          style={{ flex: 1, background: 'transparent', border: 'none', outline: 'none', padding: '10px 4px', fontSize: '14px', color: 'var(--text-primary)' }}
        />
        <button
          data-testid={`newsletter-${source}-submit-button`}
          type="submit"
          disabled={sending}
          className="meta-text"
          style={{ background: 'none', border: 'none', cursor: 'pointer', color: 'var(--text-primary)', padding: '10px 4px', opacity: sending ? 0.5 : 1, transition: 'opacity 0.2s ease' }}
        >
          {sending ? '…' : t(nl.button)}
        </button>
      </form>
      <p data-testid={`newsletter-${source}-consent`} style={{ fontSize: '12px', color: 'var(--text-secondary)', marginTop: '12px', lineHeight: 1.6 }}>{t(nl.consent)}</p>
    </div>
  );
};
